import { Injectable, inject, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToastService } from '../../services/toast.service';

// Header fijo para poder identificar y cerrar el toast 
const OFFLINE_TOAST_HEADER = 'Sin conexión a Internet';

@Injectable({ providedIn: 'root' })
export class ConnectionService implements OnDestroy {
  private readonly toast = inject(ToastService);

  private readonly _isOnline = new BehaviorSubject<boolean>(navigator.onLine);
  //Observable del estado de conexión.
  public readonly isOnline$ = this._isOnline.asObservable();

  get isOnline(): boolean {
    return this._isOnline.value;
  }

  private readonly onOnline  = () => this.handleOnline();
  private readonly onOffline = () => this.handleOffline();

  constructor() {
    window.addEventListener('online',  this.onOnline);
    window.addEventListener('offline', this.onOffline);
  }

  ngOnDestroy(): void {
    window.removeEventListener('online',  this.onOnline);
    window.removeEventListener('offline', this.onOffline);
  }

  public notifyNoConnection(): void {
    this.toast.show({
      color:    'danger',
      header:   OFFLINE_TOAST_HEADER,
      message:  'Verifica tu red e inténtalo de nuevo.',
      delay:    6000,
      autohide: true,
    });
  }

  private handleOnline(): void {
    this._isOnline.next(true);

    this.toast.removeByHeader(OFFLINE_TOAST_HEADER);

    this.toast.show({
      color:    'success',
      header:   'Conexión restablecida',
      message:  'Ya tienes acceso a Internet.',
      delay:    4000,
      autohide: true,
    });
  }

  private handleOffline(): void {
    this._isOnline.next(false);
    this.toast.show({
      color:    'warning',
      header:   OFFLINE_TOAST_HEADER,
      message:  'Por favor, revisa tu red e inténtalo de nuevo.',
      delay:    0,
      autohide: false, // persiste hasta que se restaure la conexión
    });
  }
}
